module.exports = __webpack_public_path__ + "img/dialpad-black.30aed6d8.svg";